import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowRefresh06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5.212 18.788a9.6 9.6 0 0 1 8.725-16.192m5.802 3.722c2.766 3.756 2.449 9.07-.95 12.47A9.6 9.6 0 0 1 9.77 21.34M17.837 7.86v-3.6h3.6zM6.06 16.037v3.6h-3.6z"
    />
  </svg>
);
export default SvgArrowRefresh06;
